import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3a4a3f76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "yt-notif" }
const _hoisted_2 = { class: "yt-notif__header" }
const _hoisted_3 = { class: "yt-notif__title-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "yt-notif__icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-bell" })
], -1))
const _hoisted_5 = { class: "yt-notif__title" }
const _hoisted_6 = { class: "yt-notif__subtitle" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-xmark" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "yt-notif__login"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "yt-notif__login-icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-bell-slash" })
], -1))
const _hoisted_12 = {
  class: "yt-notif__tabs",
  role: "tablist"
}
const _hoisted_13 = ["aria-selected", "onClick"]
const _hoisted_14 = { class: "yt-notif__list" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "yt-notif__dot",
  "aria-hidden": "true"
}
const _hoisted_17 = {
  key: 1,
  class: "yt-notif__dot yt-notif__dot--empty",
  "aria-hidden": "true"
}
const _hoisted_18 = { class: "yt-notif__body" }
const _hoisted_19 = { class: "yt-notif__message" }
const _hoisted_20 = { class: "yt-notif__meta" }
const _hoisted_21 = {
  key: 0,
  class: "yt-notif__meta-sep"
}
const _hoisted_22 = {
  key: 0,
  class: "yt-notif__empty"
}

import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useInboxNotifications, type InboxItem } from '@/composables/useInboxNotifications'

type NotifFilter = 'all' | 'unread' | 'read'

const drawerWidth = 400

export default /*#__PURE__*/_defineComponent({
  __name: 'DrawerNotification',
  props: /*#__PURE__*/_mergeModels({
    isLogin: { type: Boolean, default: false }
  }, {
    "open": { type: Boolean, ...{ default: false } },
    "openModifiers": {},
    "hasUnread": { type: Boolean, ...{ default: false } },
    "hasUnreadModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(["require-login"], ["update:open", "update:hasUnread"]),
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const open = _useModel<boolean>(__props, 'open')
const hasUnread = _useModel<boolean>(__props, 'hasUnread')

const { t } = useI18n()
const { items, unreadCount, fetchInbox, markRead } = useInboxNotifications()

const notifFilter = ref<NotifFilter>('all')

const notifTabs = computed(() => [
  { key: 'all' as NotifFilter, label: t('header.notifAll') },
  { key: 'unread' as NotifFilter, label: t('header.notifUnread') },
  { key: 'read' as NotifFilter, label: t('header.notifRead') },
])

const filteredNotifications = computed(() => {
  if (notifFilter.value === 'unread') {
    return items.value.filter((n) => !n.read)
  }
  if (notifFilter.value === 'read') {
    return items.value.filter((n) => n.read)
  }
  return items.value
})

const close = () => {
  open.value = false
}

const goLogin = () => {
  close()
  emit('require-login')
}

const markNotifRead = (item: InboxItem) => {
  if (!props.isLogin) return
  void markRead(item)
}

watch(
  () => props.isLogin,
  (ok) => {
    if (ok) void fetchInbox()
    else {
      items.value = []
      hasUnread.value = false
    }
  },
  { immediate: true }
)

watch(open, (visible) => {
  if (visible && props.isLogin) void fetchInbox()
})

watch(
  unreadCount,
  (n) => {
    hasUnread.value = props.isLogin && n > 0
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    open: open.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((open).value = $event)),
    placement: "right",
    width: drawerWidth,
    closable: false,
    title: null,
    "root-class-name": "yt-notif-drawer-root",
    class: "yt-notif-drawer",
    "body-style": { padding: 0, height: '100%' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('header.notifTitle')), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('header.notifSubtitle')), 1)
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "yt-notif__close",
            "aria-label": _ctx.$t('header.close'),
            onClick: close
          }, _hoisted_9, 8, _hoisted_7)
        ]),
        (!_ctx.isLogin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('header.notifLoginTitle')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('header.notifLoginDesc')), 1),
              _createElementVNode("button", {
                type: "button",
                class: "yt-notif__login-btn",
                onClick: goLogin
              }, _toDisplayString(_ctx.$t('loginForm.login')), 1)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifTabs.value, (tab) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: tab.key,
                    type: "button",
                    role: "tab",
                    class: _normalizeClass(["yt-notif__tab", { 'is-active': notifFilter.value === tab.key }]),
                    "aria-selected": notifFilter.value === tab.key,
                    onClick: ($event: any) => (notifFilter.value = tab.key)
                  }, _toDisplayString(tab.label), 11, _hoisted_13))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredNotifications.value, (item) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: item.id,
                    type: "button",
                    class: _normalizeClass(["yt-notif__item", { 'is-unread': !item.read }]),
                    onClick: ($event: any) => (markNotifRead(item))
                  }, [
                    (!item.read)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17)),
                    _createElementVNode("span", {
                      class: "yt-notif__logo",
                      style: _normalizeStyle(item.logo ? { backgroundImage: `url(${item.logo})` } : undefined)
                    }, [
                      (!item.logo)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: _normalizeClass(["fa-solid", item.eventType && String(item.eventType).includes('POINT') ? 'fa-coins' : 'fa-bell'])
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ], 4),
                    _createElementVNode("span", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, [
                        _createElementVNode("strong", null, _toDisplayString(item.title), 1),
                        _createTextVNode(" " + _toDisplayString(item.content), 1)
                      ]),
                      _createElementVNode("span", _hoisted_20, [
                        _createTextVNode(_toDisplayString(item.time) + " ", 1),
                        (item.eventType)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, "•"))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(item.eventType), 1)
                      ])
                    ])
                  ], 10, _hoisted_15))
                }), 128)),
                (!filteredNotifications.value.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.$t('header.notifEmpty')), 1))
                  : _createCommentVNode("", true)
              ])
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})